import { handleChangeHeight } from 'app/utils/helpers';
import React, { FunctionComponent } from 'react';
import styles from './TextInput.module.scss';
import { _t } from 'app/utils/i18n';
import { Link } from 'react-router-dom';
import { path } from 'app/utils/path';
import { getFromLocalStorage } from 'app/utils/localStorage';
interface Props {
  placeholder?: string;
  value?: string | { label: string; value: string };
  icon?: JSX.Element;
  label?: string;
  error?: any;
  onChange?: (value: string) => void;
  name: string;
  type?: string;
  register?: any;
  defaultValue?: any;
  disabled?: boolean;
  autoHeight?: boolean;
  autoFocus?: boolean;
  cols?: number;
  required?: boolean;
  dir?: string;
  onBlur?: () => void;
  showErrorWithoutFocus?: boolean;
  link?: string;
  iconWithBorder?: boolean;
}

const TextInput: FunctionComponent<Props> = ({
  placeholder,
  value,
  onChange = () => null,
  label,
  error,
  icon,
  name,
  type = 'text',
  register = () => null,
  defaultValue,
  disabled,
  autoHeight,
  cols,
  autoFocus,
  required,
  dir,
  onBlur,
  showErrorWithoutFocus,
  link,
  iconWithBorder,
}) => {
  const hasError =
    (typeof error == 'object' && error[name]) ||
    (typeof error == 'string' && error);
  const isEn = getFromLocalStorage('LNG') == 'en';
  return (
    <div
      className={styles.InputWrapper}
      style={cols ? { minHeight: cols } : undefined}
      data-testid={'text-input-test'}
    >
      <div className={styles.label_required}>
        {label && (
          <label
            aria-labelledby={label}
            htmlFor={name}
            style={label!==" "?{paddingRight:'10px'}:{}}
            className={`${hasError ? styles.LabelError : ''} ${
              disabled ? 'labelDisabled' : ''
            }`}
          >
            {label} {required && '*'}
          </label>
        )}
        {error && (
          <p
            data-testid={`${name}-error-testid`}
            style={{ flex: 1}}
            id={`${name}-error`}
          >
            {typeof error == 'object' ? error[name]?.message : error}
          </p>
        )}
        {link && (
          <Link to={`/${link}`} target="_blank">
            <p data-testid={`see_more`}>{_t('news:click_here')}</p>
          </Link>
        )}
      </div>
      <div className={styles.TextInput}>
        {icon && (
          <i
            className={
              `${iconWithBorder ? styles.iconWithBorder : ''} ` +
              `${iconWithBorder ? (isEn ? styles.iconRightBorder : styles.iconLeftBorder) : ''}`
            }
          >
            {icon}
          </i>
        )}
        {!autoHeight ? (
          <input
            className={
              `${icon ? (iconWithBorder ? styles.addIconWithBorder : styles.addIcon) : ''} ` +
              `${hasError ? styles.InputError : ''} ` +
              `${disabled ? styles.InputDisabled : ''} ` +
              `${
                hasError && showErrorWithoutFocus
                  ? styles.InputErrorWithoutFocus
                  : ''
              }`
            }
            data-testid={`${name}-testid`}
            type={type}
            autoComplete="off"
            placeholder={placeholder}
            onChange={(e) => onChange?.(e.target.value)}
            defaultValue={defaultValue}
            disabled={disabled}
            autoFocus={autoFocus}
            name={name}
            key={value === null ? value : undefined}
            {...register(name)}
            value={typeof value !== 'string' ? value?.value : value}
            dir={dir ? dir : ''}
            onBlur={onBlur}
          />
        ) : (
          <textarea
            className={
              `${icon ? styles.addIcon : ''} ` +
              `${hasError ? styles.InputError : ''} ` +
              `${disabled ? styles.InputDisabled : ''} `
            }
            data-testid={`${name}-testid`}
            type={type}
            placeholder={placeholder}
            onChange={(e) => onChange?.(e.target.value)}
            value={value}
            defaultValue={defaultValue}
            disabled={disabled}
            {...register(name)}
            onInput={handleChangeHeight}
            style={cols ? { minHeight: cols } : undefined}
            autoFocus={autoFocus}
          />
        )}
      </div>
    </div>
  );
};

export default TextInput;
